import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LandingService {

  deleteSubject = new Subject();
  creditInvoiceSubject = new Subject();
  creditRebillInvoiceSubject = new Subject();
  partialCreditSubject = new Subject();
  refreshGridSubject = new Subject();
  downloadPastInvoiceSubject = new Subject();
  showInvoiceHistorySubject = new Subject();
  showDocumentHistorySubject = new Subject();
  downloadDocumentSubject = new Subject();
  downloadProformaFeeAdvisorSubject = new Subject();
  userSurveySubject = new Subject();
  userSurveyResponseSubject = new Subject();

  deleteInvoice(invoiceRow) {
    this.deleteSubject.next(invoiceRow);
  }

  creditBillInvoice(transactionData) {
    this.creditInvoiceSubject.next(transactionData);
  }

  creditRebillInvoice(transactionData) {
    this.creditRebillInvoiceSubject.next(transactionData);
  }

  submitPartialCredit(transactionData) {
    this.partialCreditSubject.next(transactionData);
  }

  refreshGrid() {
    this.refreshGridSubject.next(true);
  }

  downloadInvoice(invoiceRow) {
    this.downloadPastInvoiceSubject.next(invoiceRow);
  }

  showInvoiceHistory(event) {
    this.showInvoiceHistorySubject.next(event);
  }

  showDocumentHistory(event) {
    this.showDocumentHistorySubject.next(event);
  }

  downloadDocument(invoiceRow) {
    this.downloadDocumentSubject.next(invoiceRow);
  }

  downloadProformaFeeAdvisor(invoiceRow) {
    this.downloadProformaFeeAdvisorSubject.next(invoiceRow);
  }
}
